import {
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/form-control'
import { Select } from '@chakra-ui/select'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'

interface SelectFieldProps<T> {
  name: keyof T
  label: string
  options: Array<{ label: string, value: string }>
  required?: boolean
  isDisabled?: boolean
}

function SelectField<T>({
  name,
  label,
  options,
  required,
  isDisabled,
}: SelectFieldProps<T>): React.ReactElement {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps<string, T>) => (
        <FormControl
          name={field.name}
          isDisabled={isDisabled}
          isInvalid={Boolean(
            form.errors[field.name] && form.touched[field.name],
          )}
          isRequired={required}
        >
          <FormLabel>{label}</FormLabel>
          <Select {...field} placeholder={label}>
            <option />
            {options.map(x => (
              <option key={x.value} value={x.value}>
                {x.label}
              </option>
            ))}
          </Select>
          <FormErrorMessage marginBottom="-2.0408em">
            {form.errors[field.name]}
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

export default SelectField
